import { Container } from "./styles";

export default function NoticePage() {
  return (
    <Container>
      
    </Container>
  )
}